import React from "react";
import Card from "react-bootstrap/Card";

function WorkExperience() {
  const experiences = [
    {
      company: "Tata Consultancy Services",
      role: "System Engineer",
      time: "Nov 2022 — Present",
      points: [
        "Contributed to the TCS BaNCS Capital Markets platform, working on cash, pricing, and settlement workflows.",
        "Built backend enhancements using Python, Java, React, JavaScript, XML, and MySQL.",
        "Resolved production issues, implemented workflow improvements, and supported financial messaging systems.",
        "Participated in client discussions and requirement analysis to ensure successful delivery.",
      ],
    },
    {
      company: "Fittlyf",
      role: "Django Developer",
      time: "Sept 2021 — Oct 2021",
      points: [
        "Improved the Fittlyf website by implementing multiple usability and UI enhancements.",
        "Used Django, JavaScript, jQuery, Bootstrap, HTML, and CSS to improve performance and functionality.",
        "Collaborated with marketing teams to build custom landing pages for targeted audiences.",
      ],
    },
  ];

  return (
    <section className="work-section" id="work-id">
      <div className="left my-4">
        <h1>WORK EXPERIENCE</h1>
      </div>

      <div className="work-grid">
        {experiences.map((experience, index) => (
          <Card className="work-card" key={index}>
            <Card.Body className="work-body">
              <div className="work-header">
                <h3>{experience.company}</h3>
                <span className="work-role">{experience.role}</span>
              </div>

              <ul className="work-points">
                {experience.points.map((point, pointIndex) => (
                  <li key={pointIndex}>{point}</li>
                ))}
              </ul>

              <div className="work-time">{experience.time}</div>
            </Card.Body>
          </Card>
        ))}
      </div>
    </section>
  );
}

export default WorkExperience;